import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

export const BackLibrary = ({ user }) => {
  const navigate = useNavigate();
  const goTo = (link) => {
    navigate(link);
  };
  return (
    <button
      className="btn btn-light bg-white"
      id="yourLibrary"
      onClick={() => {
        if (user?.user?.isAdmin) {
          goTo("/user-documents");
        } else {
          goTo("/dashboard");
        }
      }}
    >
      <ArrowBackIosIcon />{" "}
      {user?.user?.isAdmin ? "Go Back To Documents" : "Your Library"}
    </button>
  );
};
